const REGION_PAYMENT_METHODS = Object.freeze({
  KR: ['creditcard_kr', 'ebanking_kr', 'kakaopay_kr', 'payco_kr', 'ssgpay_kr', 'samsungpay_kr'],
  HK: ['alipayhk_hk', 'alipay_hk'],
  TW: ['alipay_tw', 'jko_tw'],
  OTHER: ['alipay_hk']
})

const SUPPORTED_LOCALE_REGIONS = Object.freeze([
  'KR',
  'HK',
  'TW',
  'OTHER',
  'CN',
  'US',
  'GB',
  'AU',
  'CA',
  'SG',
  'MY',
  'TH',
  'VN',
  'ID',
  'PH',
  'JP'
])

export const REGION_UNKNOWN = 'UNKNOWN'
export const REGION_OTHER = 'OTHER'

const PAYMENT_METHOD_META = Object.freeze({
  creditcard_kr: {
    labelKey: 'indexPage.pay.creditcardKR',
    icon: require('@/assets/Korea_credit _card.png')
  },
  ebanking_kr: {
    labelKey: 'indexPage.pay.ebankingKR',
    icon: require('@/assets/Internet_banking .png')
  },
  kakaopay_kr: {
    labelKey: 'indexPage.pay.kakaopay',
    icon: require('@/assets/KAKAOPAY-copy.png')
  },
  payco_kr: {
    labelKey: 'indexPage.pay.payco',
    icon: require('@/assets/Payco.png')
  },
  ssgpay_kr: {
    labelKey: 'indexPage.pay.ssgpay',
    icon: require('@/assets/ssgpay.png')
  },
  samsungpay_kr: {
    labelKey: 'indexPage.pay.samsungpay',
    icon: require('@/assets/samsungpay.png')
  },
  alipayhk_hk: {
    labelKey: 'indexPage.pay.alipayWalletHK',
    icon: require('@/assets/alipay.png')
  },
  alipay_hk: {
    labelKey: 'indexPage.pay.alipayHK',
    icon: require('@/assets/alipay.png')
  },
  alipay_tw: {
    labelKey: 'indexPage.pay.alipayTW',
    icon: require('@/assets/alipay.png')
  },
  jko_tw: {
    labelKey: 'indexPage.pay.jkoTW',
    icon: require('@/assets/icon_pay.png')
  }
})

const REGION_LOCALE_MAP = Object.freeze({
  KR: 'ko',
  HK: 'zh-TW',
  TW: 'zh-TW',
  OTHER: 'en',
  CN: 'en', // 中国大陆默认英文
  US: 'en',
  GB: 'en',
  AU: 'en',
  CA: 'en',
  SG: 'en',
  MY: 'en',
  TH: 'en',
  VN: 'en',
  ID: 'en',
  PH: 'en',
  JP: 'en'
})

const VALID_LOCALES = ['zh-TW', 'en', 'ko']

export const DEFAULT_REGION_CONTEXT = Object.freeze({
  region: REGION_OTHER,
  regionName: '',
  locale: 'en',
  paymentMethods: [...REGION_PAYMENT_METHODS.OTHER],
  defaultPmId: REGION_PAYMENT_METHODS.OTHER[0],
  ip: ''
})

function resolveRegionPaymentMethods(region) {
  const normalizedRegion = normalizeRegionCode(region)
  const regionPaymentMethods = REGION_PAYMENT_METHODS[normalizedRegion]
  if (Array.isArray(regionPaymentMethods) && regionPaymentMethods.length > 0) {
    return [...regionPaymentMethods]
  }
  return [...REGION_PAYMENT_METHODS.OTHER]
}

export function normalizeRegionCode(region) {
  if (!region) {
    return DEFAULT_REGION_CONTEXT.region
  }
  const normalized = String(region).trim().toUpperCase()
  if (normalized === REGION_UNKNOWN) {
    return REGION_OTHER
  }
  return REGION_PAYMENT_METHODS[normalized] || SUPPORTED_LOCALE_REGIONS.includes(normalized)
    ? normalized
    : DEFAULT_REGION_CONTEXT.region
}

export function requiresManualPaymentSelection(region) {
  return false
}

export function normalizeRegionContext(payload = {}) {
  const region = normalizeRegionCode(payload.region)
  const regionName = payload.regionName
  const paymentCandidates = Array.isArray(payload.paymentMethods) ? payload.paymentMethods : []
  const paymentMethods = paymentCandidates.filter((pmId) => PAYMENT_METHOD_META[pmId])
  const normalizedPaymentMethods = paymentMethods.length > 0
    ? paymentMethods
    : resolveRegionPaymentMethods(region)
  const defaultPmId = normalizedPaymentMethods.includes(payload.defaultPmId)
    ? payload.defaultPmId
    : normalizedPaymentMethods[0]

  const localeFromPayload = payload.locale && VALID_LOCALES.includes(payload.locale)
    ? payload.locale
    : resolveLocaleByRegion(region)

  return {
    region,
    regionName,
    locale: localeFromPayload,
    paymentMethods: normalizedPaymentMethods,
    defaultPmId,
    ip: payload.ip || ''
  }
}

export function resolveLocaleByRegion(region) {
  const normalizedRegion = normalizeRegionCode(region)
  return REGION_LOCALE_MAP[normalizedRegion] || DEFAULT_REGION_CONTEXT.locale
}

export function resolvePaymentMethodCards(paymentMethods = []) {
  return paymentMethods
    .map((pmId) => {
      const meta = PAYMENT_METHOD_META[pmId]
      if (!meta) {
        return null
      }
      return {
        pmId,
        labelKey: meta.labelKey,
        icon: meta.icon
      }
    })
    .filter(Boolean)
}
